<template>
  <component
    :is="modalComponent || initialComponent"
    :key="keyId"
    :bio-material-bundles="bioMaterialBundles"
    v-bind="$attrs"
  />
</template>

<script>
import { useQueryString } from "@/composables/useQueryString";
import BioMaterialTypeSelect from "./BioMaterialTypeSelect.vue";
import BioProjectMaterialsBModal from "./BioProjectMaterialsBModal.vue";
import SearchAddFromLibraryModal from "./SearchAddFromLibraryModal.vue";

export default {
  name: "QueryModals",
  components: {
    BioMaterialTypeSelect,
    BioProjectMaterialsBModal,
    SearchAddFromLibraryModal,
  },
  data() {
    return {
      modalComponent: null,
      bioMaterialBundles: [],
    };
  },
  setup() {
    const { params, paramsUpdated } = useQueryString();
    return { params, paramsUpdated };
  },
  computed: {
    initialComponent() {
      return this.params.get("modal") ?? "div";
    },
    keyId() {
      return this.paramsUpdated;
    },
  },
  methods: {
    getBundles() {
      this.bioMaterialBundles = JSON.parse(this.params.get("bundles"));
    },
  },
  mounted() {
    this.getBundles();
  },
  watch: {
    keyId() {
      this.modalComponent = this.params.get("modal");
      this.getBundles();
    },
  },
};
</script>

<!-- Watch for URL modal query here to open modal -->
<!-- Modals emit event when they're done, go to destination -->
